import { gql } from "@apollo/client";

export const FORGOT_PASSWORD = gql`
  mutation forgotPassAdmins($forgotPasswordData: ForgotPasswordInput!) {
    forgotPassAdmins(forgotPasswordData: $forgotPasswordData) {
      sessionToken
    }
  }
`;
